import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import NotFound from './components/NotFound';
import Subscription from './pages/Subscriptions';
import Store from './components/Store';
import Register from './pages/Register/Register';
import LoadingSpinner from './pages/LoadingSpinner';

const ForgetPassword = React.lazy(() => import('./components/ForgetPassword'));
const Thanks = React.lazy(() => import('./components/Thanks'));
const ThanksBusiness = React.lazy(() => import('./components/ThanksBusiness'));
const Blog = React.lazy(() => import('./components/Blog'));
const BlogTwo = React.lazy(() => import('./components/BlogTwo'));
const Terms = React.lazy(() => import('./components/Terms'));
const Policy = React.lazy(() => import('./components/Policy'));
const UpgradeCompleted = React.lazy(() =>
  import('./pages/UpgradeCompleted/UpgradeCompleted')
);
const UpgradeFailed = React.lazy(() =>
  import('./pages/UpgradeFailed/UpgradeFailed')
);
const PendingSubs = React.lazy(() =>
  import('./pages/PendingSubscription/PendingSubs')
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}>
    <React.Suspense
      fallback={
        <div className='flex justify-center items-center h-screen'>
          <LoadingSpinner />
        </div>
      }>
      <Routes>
        <Route path='/' element={<App />} />
        <Route path='/thanks' element={<Thanks />} />
        <Route path='/thanksbusiness' element={<ThanksBusiness />} />
        <Route path='/auth/reset-password-web' element={<ForgetPassword />} />
        <Route
          path='/blog/embracing-personal-care-together'
          element={<Blog />}
        />
        <Route
          path='/blog/5-Benefits-of-having-a-system-for-personal-care-business'
          element={<BlogTwo />}
        />
        <Route path='/termsofuse' element={<Terms />} />
        <Route path='/privacypolicy' element={<Policy />} />
        <Route path='/store' element={<Store />} />
        <Route path='/business' element={<Store />} />
        <Route path='/business/:id' element={<Store />} />
        <Route path='/offers' element={<Store />} />
        <Route path='/externalBusinessRequest' element={<Register />} />
        <Route
          path='/subscriptions/:businessid/:userid/:token/:selectedplan/:isyearly/:WLR'
          element={<Subscription />}
        />
        <Route path='/subscription-succeeded' element={<UpgradeCompleted />} />
        <Route path='/subscription-failed' element={<UpgradeFailed />} />
        <Route path='/pending-subscription' element={<PendingSubs />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </React.Suspense>
  </Router>
);
